/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, SAISON){
	const a = 'is-active';
	const v = 'is-visible';
	const $map = location.pathname;

	const addPlus = (_val) => {
		if(_val.charAt(0) !== '-') {
			_val = '+' + _val;
		}
		return _val;
	};
	
	// <シミュレーションとモデルケース> グラフ描画
	const csvLoad = (_name) => {
		let labelsArr = [],
			dataArr1 = [],
			dataArr2 = [],
			idArr = [],
			color1,
			color2,
			$valuation,
			$labelRotate,
			$fontSize;
		const ctx = document.getElementById(`myChart-${_name}`);

		// リサイズでラベルの角度変更
		$(window).on('resize', function(){
			let winW = $(window).width();
			if(winW <= 768) {
				$labelRotate = 45;
				$fontSize = 8;
			} else if(winW <= 1204) {
				$labelRotate = 45;
				$fontSize = 9;
			} else {
				$labelRotate = 0;
				$fontSize = 10;
			}
		}).resize();
		// 色
		if(_name === 'global') {
			color1 = '#0099cc';
			color2 = '#e8f9ff';
		} else if(_name === 'master') {
			color1 = '#ff0033';
			color2 = '#ffeff2';
		}

		const req = new XMLHttpRequest();
		req.open('get', `/fund/teiki/modelcase/graphData_${_name}.csv`, true);
		req.send(null);
		req.onload = function(){
			let tmp = req.responseText.split('\n');
			tmp.shift();

			let newDate = tmp[0].split(',')[0];
			$('.js-graph-date').text(newDate);

			tmp.forEach((val, idx) => {
				const data = val.split(',').filter(Boolean);
				const data2 =  data.filter(Boolean);

				let data1Index = tmp[1].split(',').indexOf('評価額');
				let data3Index = tmp[1].split(',').indexOf('元本');

				if(data2.indexOf('時価') !== -1) {
					let thisVal = data2[1];
					$valuation = Math.trunc(thisVal / 10000);
				}

				labelsArr.push(data2[1]);
				if($.isNumeric(data2[0])) {
					idArr.push(data2[0]);
				}

				// 評価額
				if(data2[data1Index] !== undefined) {
					dataArr1.push(data2[data1Index]);
				}
				// 累計口数(投資価格)
				if(data2[data3Index] !== undefined) {
					dataArr2.push(data2[data3Index]);
				}
			});

			labelsArr.shift();
			labelsArr.shift();
			dataArr1.shift();
			dataArr2.shift();

			let yArr1 = [];
			let yArr2 = [];

			labelsArr.forEach((val, idx) => {
				yArr1.push(String(labelsArr[idx]).split('/')[0] +'年');
			});

			let endIndex = idArr.length;
			dataArr2.splice(endIndex, dataArr2.length - endIndex);
			labelsArr.splice(endIndex, yArr1.length - endIndex);
			yArr1.splice(endIndex, yArr1.length - endIndex);

			yArr2 = yArr1.filter((x, i, self) => self.indexOf(x) === i);

			let oldestDate = labelsArr[0].split('/');
			let latestDate = labelsArr[labelsArr.length -1].split('/');
			$('.js-oldest').text(oldestDate[0] +'年'+ oldestDate[1] +'月');
			$('.js-latest').text(latestDate[0] +'年'+ latestDate[1] +'月');

			// Chart.defaults.global.defaultFontColor = '#000';
			// let myChart = new Chart(ctx, {
			// 	type: 'bar',
			// 	data: {
			// 		labels: yArr1,
			// 		datasets: [{
			// 			label: '評価額',
			// 			type: 'line',
			// 			tension: 0,
			// 			fill: false,
			// 			data: dataArr1,
			// 			borderColor: color1,
			// 			yAxisID: 'y-axis-1',
			// 		}, {
			// 			label: '投資金額',
			// 			type: 'line',
			// 			tension: 0,
			// 			data: dataArr2,
			// 			backgroundColor: color2,
			// 			borderColor: color2,
			// 			yAxisID: 'y-axis-2',
			// 		}]
			// 	},
			// 	options: {
			// 		tooltips: {
			// 			mode: 'nearest',
			// 			intersect: false,
			// 		},
			// 		responsive: true,
			// 		elements: {
			// 			point:{
			// 				radius: 0
			// 			}
			// 		},
			// 		scales: {
			// 			yAxes: [{
			// 				id: 'y-axis-1',
			// 				type: 'linear',
			// 				position: 'left',
			// 				ticks: {
			// 					// max: 5000000,
			// 					min: 0,
			// 					stepSize: 500000,
			// 					title: '評価額',
			// 					fontSize: $fontSize,
			// 					callback: function(val){
			// 						return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
			// 					},
			// 				},
			// 				gridLines: {
			// 					zeroLineColor: '#000',
			// 					drawBorder: false,
			// 				}
			// 			}, {
			// 				id: 'y-axis-2',
			// 				type: 'linear',
			// 				position: 'right',
			// 				ticks: {
			// 					// display: false,
			// 					// max: 5000000,
			// 					min: 0,
			// 					stepSize: 500000,
			// 					title: '投資金額',
			// 				},
			// 				gridLines: {
			// 					// display: false,
			// 				}
			// 			}],
			// 			xAxes: [{
			// 				gridLines: {
			// 					color: 'transparent',
			// 					zeroLineColor: 'transparent'
			// 				},
			// 				barPercentage: 0.7,
			// 				ticks: {
			// 					maxTicksLimit: yArr2.length,
			// 					fontSize: $fontSize,
			// 					maxRotation: 45,
			// 					minRotation: 45,
			// 					callback: function(val){
			// 						return val.split('/')[0];
			// 					}
			// 				}
			// 			}]
			// 		}
			// 	}
			// });

			// // 「投資金額」の目盛りを「評価額」に合わせる
			// const updateScale = () => {
			// 	const yAxis1Index = myChart.controller.boxes.findIndex((u) => u.id === 'y-axis-1');
			// 	myChart.options.scales.yAxes[1] = {
			// 		ticks: {
			// 			display: false,
			// 			max: myChart.controller.boxes[yAxis1Index].end
			// 		},
			// 		gridLines: {
			// 			display: false,
			// 		}
			// 	};
			// 	myChart.update();
			// };
			// updateScale();

			// 投資金額・評価額
			let $investment = idArr[idArr.length -1];
			$('.'+_name).find('.js-graph-investment').text($investment);
			$('.'+_name).find('.js-graph-valuation').text($valuation);

		};
	};

	// <シミュレーションとモデルケース> 年換算収益率
	const modelcaseReturn = (_name) => {
		const req = new XMLHttpRequest();
		req.open('get', `/fund/${_name}/status/graphData_${_name}_status.csv`, true);
		req.send(null);
		req.onload = function(){
			let tmp = req.responseText.split('\n');
			tmp.shift();
			tmp.shift();

			tmp.forEach((val, idx) => {
				// 設定来の年換算収益率
				if(tmp[idx].indexOf('設定来の年換算収益率（概算値）') !== -1) {
					let thisLeftIdx = tmp[idx].split(',').indexOf('設定来の年換算収益率（概算値）');
					let thisArr = tmp[idx +1].split(',').filter(Boolean);
					thisArr.splice(0, thisLeftIdx-1);
					$(`.js-modelcase-${_name}`).find('.js-return').text(thisArr[1]);
					$('.js-modelcase-date').text(thisArr[0].replace('現在', ''));
				}
			});

		};
	};

	// <運用状況・レポート>
	const scvLoadStatus = (_name) => {
		let labelsArr = [],
			dataArr1 = [],
			dataArr2 = [],
			color1, color2,
			// max1, max2,
			step1, step2,
			$fontSize;
		const ctx = document.getElementById(`myChart-${_name}-status`);

		// リサイズでラベルの角度変更
		$(window).on('resize', function(){
			let winW = $(window).width();
			if(winW <= 768) {
				$fontSize = 8;
			} else if(winW <= 1204) {
				$fontSize = 14;
			}
		}).resize();
		// 色、最大値、最小値
		if(_name === 'global') {
			color1 = '#96D9C1';
			color2 = '#0099cc';
			// max1 = 3000;
			// max2 = 20000;
			step1 = 500;
			step2 = 2000;
		} else if(_name === 'master') {
			color1 = '#96D9C1';
			color2 = '#ff0033';
			// max1 = 2000;
			// max2 = 40000;
			step1 = 100;
			step2 = 2000;
		}

		const req = new XMLHttpRequest();
		req.open('get', `/fund/${_name}/status/graphData_${_name}_status.csv`, true);
		req.send(null);
		req.onload = function(){
			let tmp = req.responseText.split('\n');
			tmp.shift();
			tmp.shift();

			let period = tmp[0].split(',')[0];
			$('.js-period').text(period);

			tmp.forEach((val, idx) => {
				const data = val.split(',').filter(Boolean);
				const data2 =  data.filter(Boolean);

				let data1Index = tmp[1].split(',').indexOf('グラフ（純資産総額）：億円');
				let data2Index = tmp[1].split(',').indexOf('グラフ（基準価額）：円');

				if(data2[0] !== undefined) {
					labelsArr.push(data2[0]);
				}

				// 純資産総額
				if(data2[data1Index] !== undefined) {
					dataArr1.push(data2[data1Index]);
				}
				// 基準価格
				if(data2[data2Index] !== undefined) {
					dataArr2.push(data2[data2Index]);
				}

				// 基準価額騰落率
				if(tmp[idx].indexOf('基準価額騰落率') !== -1) {
					let thisLeftIdx = tmp[idx].split(',').indexOf('基準価額騰落率');
					let thisArr = tmp[idx +1].split(',').filter(Boolean);
					thisArr.splice(0, thisLeftIdx-1);

					$(`.js-statusTbl02-${_name}`).find('.js-csv-date').text(thisArr[0]);
					$(`.js-statusTbl02-${_name}`).find('.js-csv-data1').text(addPlus(thisArr[1]));
					$(`.js-statusTbl02-${_name}`).find('.js-csv-data2').text(addPlus(thisArr[2]));
					$(`.js-statusTbl02-${_name}`).find('.js-csv-data3').text(addPlus(thisArr[3]));
					$(`.js-statusTbl02-${_name}`).find('.js-csv-data4').text(addPlus(thisArr[4]));
					$(`.js-statusTbl02-${_name}`).find('.js-csv-data5').text(addPlus(thisArr[5]));
				}

				// 設定来の年換算収益率
				if(tmp[idx].indexOf('設定来の年換算収益率（概算値）') !== -1) {
					let thisLeftIdx = tmp[idx].split(',').indexOf('設定来の年換算収益率（概算値）');
					let thisArr = tmp[idx +1].split(',').filter(Boolean);
					thisArr.splice(0, thisLeftIdx-1);
					$(`.js-statusTbl02-${_name}`).find('.js-return').text(thisArr[1]);
				}

				// シャープレシオ
				if(tmp[idx].indexOf('シャープレシオ') !== -1) {
					let thisLeftIdx = tmp[idx].split(',').indexOf('シャープレシオ');
					let thisArr = tmp[idx +1].split(',').filter(Boolean);
					thisArr.splice(0, thisLeftIdx-1);

					$(`.js-statusTbl03-${_name}`).find('.js-csv-date').text(thisArr[0]);
					$(`.js-statusTbl03-${_name}`).find('.js-csv-data1').text(addPlus(thisArr[1]));
					$(`.js-statusTbl03-${_name}`).find('.js-csv-data2').text(addPlus(thisArr[2]));
					$(`.js-statusTbl03-${_name}`).find('.js-csv-data3').text(addPlus(thisArr[3]));
				}

				// 定期積立プランで購入した場合の平均取得単価と損益
				if(tmp[idx].indexOf('定期積立プランで購入した場合の平均取得単価と損益') !== -1) {
					let thisLeftIdx = tmp[idx].split(',').indexOf('定期積立プランで購入した場合の平均取得単価と損益');
					let thisArr1 = tmp[idx +1].split(',').filter(Boolean);
					let thisArr2 = tmp[idx +2].split(',').filter(Boolean);
					let thisArr3 = tmp[idx +3].split(',').filter(Boolean);
					let thisArr4 = tmp[idx +4].split(',').filter(Boolean);
					let thisArr5 = tmp[idx +5].split(',').filter(Boolean);
					thisArr1.splice(0, thisLeftIdx-1);
					thisArr2.splice(0, thisLeftIdx-1);
					thisArr3.splice(0, thisLeftIdx-1);
					thisArr4.splice(0, thisLeftIdx-1);
					thisArr5.splice(0, thisLeftIdx-1);
					let data1_1 = Number(thisArr1[2]).toLocaleString() +'円';
					let data1_2 = addPlus(thisArr1[3]);
					let data2_1 = Number(thisArr2[1]).toLocaleString() +'円';
					let data2_2 = addPlus(thisArr2[2]);
					let data3_1 = Number(thisArr3[1]).toLocaleString() +'円';
					let data3_2 = addPlus(thisArr3[2]);
					let data4_1 = Number(thisArr4[1]).toLocaleString() +'円';
					let data4_2 = addPlus(thisArr4[2]);
					let basePrice = Number(thisArr5[1]).toLocaleString();

					$(`.js-statusTbl04-${_name}`).find('.js-csv-date').text(thisArr1[0]);
					$(`.js-statusTbl04-${_name}`).find('.js-csv-data1-head').text(thisArr1[1]);
					$(`.js-statusTbl04-${_name}`).find('.js-csv-data1-1').text(data1_1);
					$(`.js-statusTbl04-${_name}`).find('.js-csv-data1-2').text(data1_2);
					$(`.js-statusTbl04-${_name}`).find('.js-csv-data2-head').text(thisArr2[0]);
					$(`.js-statusTbl04-${_name}`).find('.js-csv-data2-1').text(data2_1);
					$(`.js-statusTbl04-${_name}`).find('.js-csv-data2-2').text(data2_2);
					$(`.js-statusTbl04-${_name}`).find('.js-csv-data3-head').text(thisArr3[0]);
					$(`.js-statusTbl04-${_name}`).find('.js-csv-data3-1').text(data3_1);
					$(`.js-statusTbl04-${_name}`).find('.js-csv-data3-2').text(data3_2);
					$(`.js-statusTbl04-${_name}`).find('.js-csv-data4-head').text(thisArr4[0]);
					$(`.js-statusTbl04-${_name}`).find('.js-csv-data4-1').text(data4_1);
					$(`.js-statusTbl04-${_name}`).find('.js-csv-data4-2').text(data4_2);
					$(`.js-statusTbl04-${_name}`).find('.js-basePrice').text(basePrice);
				}

				// 分配について
				if(tmp[idx].indexOf('分配について') !== -1) {
					let thisLeftIdx = tmp[idx].split(',').indexOf('分配について');
					let thisArr1 = tmp[idx +1].split(',').filter(Boolean);
					let thisArr2 = tmp[idx +2].split(',').filter(Boolean);
					let thisArr3 = tmp[idx +3].split(',').filter(Boolean);
					let thisArr4 = tmp[idx +4].split(',').filter(Boolean);
					thisArr1.splice(0, thisLeftIdx-1);
					thisArr2.splice(0, thisLeftIdx-1);
					thisArr3.splice(0, thisLeftIdx-1);
					thisArr4.splice(0, thisLeftIdx-1);
					let data1_2 = Number(thisArr1[1]).toLocaleString() +'円';
					let data2_2 = Number(thisArr2[1]).toLocaleString() +'円';
					let data3_2 = Number(thisArr3[1]).toLocaleString() +'円';
					let data4_2 = Number(thisArr4[1]).toLocaleString() +'円';


					$(`.js-statusTbl05-${_name}`).find('.js-csv-data1-1').text(thisArr1[0]);
					$(`.js-statusTbl05-${_name}`).find('.js-csv-data1-2').text(data1_2);
					$(`.js-statusTbl05-${_name}`).find('.js-csv-data2-1').text(thisArr2[0]);
					$(`.js-statusTbl05-${_name}`).find('.js-csv-data2-2').text(data2_2);
					$(`.js-statusTbl05-${_name}`).find('.js-csv-data3-1').text(thisArr3[0]);
					$(`.js-statusTbl05-${_name}`).find('.js-csv-data3-2').text(data3_2);
					$(`.js-statusTbl05-${_name}`).find('.js-csv-data4-1').text(thisArr4[0]);
					$(`.js-statusTbl05-${_name}`).find('.js-csv-data4-2').text(data4_2);
				}
			});

			labelsArr.shift();
			labelsArr.shift();
			dataArr1.shift();
			dataArr2.shift();

			// 年号ラベル設定
			let yArr1 = [];
			let yArr2 = [];
			labelsArr.forEach((val, idx) => {
				let yearTxt = labelsArr[idx];
				let yearTxt2 = labelsArr[idx].split('年')[0];
				let newYearTxt = yearTxt.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function(s) {
					return String.fromCharCode(s.charCodeAt(0) - 65248);
				});
				let newYearTxt2 = yearTxt2.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function(s) {
					return String.fromCharCode(s.charCodeAt(0) - 65248);
				});
				yArr1.push(newYearTxt);
				yArr2.push(newYearTxt2);
			});
			let yArrLastItem = yArr2[yArr1.length-1];
			let yArrLastItemLen = yArr2.filter(n => n === yArrLastItem).length;
			
			if(yArrLastItemLen < 3) {
				for(let i = 0; i < 3-yArrLastItemLen; i++) {
					yArr1.push(yArrLastItem);
				}
			}
			yArr2 = yArr2.filter((x, i, self) => self.indexOf(x) === i);

			// chart.jsプラグイン start
			// フォーカス時に縦線を表示
			Chart.plugins.register({
				id:'verticalLinePlugin',
				beforeEvent: function(chart, e) {
					const elms = Chart.Interaction.modes.nearest(chart, e, chart.tooltip._options);
					if ((elms.length > 0) &&
						(e.x >= e.chart.chartArea.left) && (e.x <= e.chart.chartArea.right) &&
						(e.y >= e.chart.chartArea.top) && (e.y <= e.chart.chartArea.bottom)) {
						chart.options.verticalLinePlugin.x = elms[0]._model.x;
					} else {
						chart.options.verticalLinePlugin.x = NaN;
					}
				},
				afterDraw: function(chart) {
					var ctx = chart.chart.ctx;
					var chartArea = chart.chartArea;
					var x = chart.options.verticalLinePlugin.x;
					if (!isNaN(x)) {
						ctx.save();
						//ラインの太さ
						ctx.lineWidth = chart.options.verticalLinePlugin.lineWidth;
						//ラインの色
						ctx.strokeStyle = chart.options.verticalLinePlugin.color;
						//点線の場合：[線の長さ, 間隔の長さ]、実線の場合：[]
						ctx.setLineDash(chart.options.verticalLinePlugin.setLineDash);
						ctx.beginPath();
						ctx.moveTo(chart.options.verticalLinePlugin.x, chartArea.bottom);
						ctx.lineTo(chart.options.verticalLinePlugin.x, chartArea.top);
						ctx.stroke();
						ctx.restore();
					}
				}
			});
			// chart.jsプラグイン end

			Chart.defaults.global.defaultFontColor = '#000';
			let myChart = new Chart(ctx, {
				type: 'line',
				data: {
					labels: yArr1,
					datasets: [{
						label: '基準価額',
						tension: 0,
						fill: false,
						data: dataArr2,
						borderColor: color2,
						yAxisID: 'y-axis-1',
					},{
						label: '純資産総額',
						tension: 0,
						data: dataArr1,
						backgroundColor: color1,
						borderColor: color1,
						yAxisID: 'y-axis-2',
					}]
				},
				options: {
					tooltips: {
						// mode: 'nearest',
						mode: 'label',
						intersect: false,
						callbacks: 
						{
							title: (tooltipItem, data) => {
								return tooltipItem[0].label;
							},
							label: function(tooltipItems, data) {
								if(tooltipItems.datasetIndex === 0){
									return data.datasets[0].label + '：' + tooltipItems.yLabel.toLocaleString() + '円'
								} else {
									return data.datasets[1].label + '：' + tooltipItems.yLabel.toLocaleString() + '億円';
								}
							}
						}
					},
					responsive: true,
					maintainAspectRatio: false,
					elements: {
						point:{
							radius: 0
						}
					},
					scales: {
						yAxes: [{
							id: 'y-axis-1',
							type: 'linear',
							position: 'left',
							ticks: {
								// max: max2,
								min: 0,
								//stepSize: step2,
								title: '基準価額',
								fontSize: $fontSize,
								callback: function(val){
									return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
								}
							},
							gridLines: {
								display: false,
							}
						}, {
							id: 'y-axis-2',
							type: 'linear',
							position: 'right',
							ticks: {
								// max: max1,
								min: 0,
								// stepSize: step1,
								title: '純資産総額',
								fontSize: $fontSize,
								callback: function(val){
									return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
								}
							},
							gridLines: {
								zeroLineColor: '#000',
								drawBorder: false,
							}
						}],
						xAxes: [{
							gridLines: {
								color: 'transparent',
								zeroLineColor: 'transparent'
							},
							barPercentage: 0.7,
							ticks: {
								autoSkip: false,
								fontSize: $fontSize,
								maxRotation: 0,
								// minRotation: 0,
								callback: function(val,idx,values) {
									let thisY = val.split('年')[0];
									if(idx !== 0) {
										if(thisY !== values[idx - 1].split('年')[0]) {
											if((thisY - yArr2[0])%3 === 0) {
												return thisY + '年';
											} else {
												return '';
											}
										}
									} else {
										return thisY + '年';
									}
								},
							},
						}]
					},
					legend: {
						display: true,
						position: 'top',
						labels: {
							generateLabels: function(data) {
								const chartData = data.tooltip._data.datasets;
								if(!$('.fund-canvas-labels-item').length) {
									for(let i = 0; i < chartData.length; i++) {
										$('.fund-canvas-labels').append(`<li class="fund-canvas-labels-item"><span class="__label" style="background-color:${chartData[i].borderColor};"></span>${chartData[i].label}</li>`);
									}
								}
							}
						}
					},
					plugins: {
						// tooltip: {
						// 	enabled: false,
						// 	mode: 'label',
						// 	intersect: false
						// },
						verticalLinePlugin: true
					},
					verticalLinePlugin: {
						color : '#000',
						lineWidth : '1',
						setLineDash : [2,2]
					}
				}
			});
		};
	};



	// ====================================================================
	// <シミュレーションとモデルケース>
	// グラフ
	if($('.js-graph.global').length) {
		csvLoad('global');
	}
	if($('.js-graph.master').length) {
		csvLoad('master');
	}
	// 設定来の年換算収益率
	if($('.js-modelcase-master').length) {
		modelcaseReturn('master');
	}
	if($('.js-modelcase-global').length) {
		modelcaseReturn('global');
	}

	// <運用状況・レポート>
	if($('#myChart-global-status').length) {
		scvLoadStatus('global');
	}
	if($('#myChart-master-status').length) {
		scvLoadStatus('master');
	}


})(window.jQuery, window.SAISON);
